const Modal = require('../common/modal');
const {FormValidator} = require('../common/form-validator');
const axios = require('../common/axios');
const Toast = require('../common/toast');
const querySelect = require('../common/query-select');
const siteUrl = require('../common/site-url');
const Chosen = require('../common/chosen');
const Tabs = require('../common/tabs');
const Dropzone = require('dropzone');
Dropzone.autoDiscover = false;

function addWrTeamFormValidityChanged(modal, valid) {
	modal.querySelectorAll('[data-confirm-modal]').forEach(function (button) {
		button.disabled = !valid
	});
}

function showProgress(element) {
	element.classList.remove('hidden');
	return Promise.resolve();
}

function hideProgress(element) {
	element.classList.add('hidden');
}

function addWrTeam(model, progress) {
	return showProgress(progress).then(
		() => axios.put(siteUrl('api/zwe/wrteam'), model)
	).then(
		(response) => reloadPage(`#team_${response.data.id}`)
	).catch(
		(error) => {
			console.error('could not create team', {error});
			Toast.add('error', 'WR-Team konnte nicht angelegt werden.')
		}
	).finally(
		() => hideProgress(progress)
	);
}

function deleteWrTeam(id, progress) {
	return showProgress(progress).then(
		() => axios.delete(siteUrl(['api/zwe/wrteam', id]))
	).then(
		() => reloadPage('#veranstaltung')
	).catch(
		(error) => {
			console.error('could not delete team', {error});
			Toast.add('error', `'WR-Team #${id} konnte nicht gelöscht werden.'`)
		}
	).finally(
		() => hideProgress(progress)
	);
}

function getProgressElement() {
	return querySelect('#veranstaltung-progress');
}

function reloadPage(tab) {
	if (tab && tab !== window.location.hash) {
		window.location.hash = tab;
	}
	window.location.reload();
}

function moveCompetition(table, row, up = true) {
	const rows = table.querySelectorAll(`tbody tr`);
	const index = Array.from(rows.values()).indexOf(row);
	if (index === -1) {
		throw new Error('could not find tr');
	}
	if (rows.length === 0) {
		throw new Error('no rows found');
	}
	if (up && index === 0) {
		throw new Error('cannot move up index 0');
	}
	if (!up && index === rows.length - 1) {
		throw new Error('cannot move down last index');
	}
	if (index > rows.length - 1) {
		throw new Error('index not in rows');
	}

	const itemToMove = row;
	itemToMove.classList.add('moving');
	setTimeout(() => {
		itemToMove.classList.remove('moving');
	}, 600);

	if (up) {
		const targetIndex = index - 1;
		rows.item(targetIndex).parentNode.insertBefore(itemToMove, rows.item(targetIndex))
	} else {
		const targetIndex = index + 1;
		rows.item(index).parentNode.insertBefore(rows.item(targetIndex), itemToMove);
	}
	updateCompetitionActionsState(findParentTable(itemToMove));
}

function updateCompetitionActionsState(table) {
	const rows = table.querySelectorAll('tbody tr');
	rows.forEach(function (element, index) {
		if (index === 0) {
			element.querySelector('.up').classList.add('disabled');
		} else {
			element.querySelector('.up').classList.remove('disabled');
		}
		if (index === rows.length - 1) {
			element.querySelector('.down').classList.add('disabled');
		} else {
			element.querySelector('.down').classList.remove('disabled');
		}
	});
}

function insertCompetitionRowBefore(row, target) {
	target.parentNode.insertBefore(row, target);
	updateCompetitionActionsState(findParentTable(row));
}

function appendCompetitionRow(row, table) {
	let tbody = table.querySelector('tbody');
	if (!tbody) {
		tbody = table.appendChild(document.createElement('tbody'))
	}
	tbody.appendChild(row);
	updateCompetitionActionsState(table);
}

function findParentRow(element) {
	if (element === document.documentElement) {
		throw new Error('could not find parent tr');
	}

	if (element instanceof HTMLTableRowElement) {
		return element;
	}

	return findParentRow(element.parentNode);
}

function findParentTable(element) {
	if (element === document.documentElement) {
		throw new Error('could not find parent table');
	}

	if (element instanceof HTMLTableElement) {
		return element;
	}

	return findParentTable(element.parentNode)
}

let draggedTrId = undefined;
let addedCompetitionIndex = 0;

function competitionDragStart(event) {
	const tr = findParentRow(event.target);
	event.dataTransfer.dropEffect = 'move';
	tr.classList.add('dragging');
	draggedTrId = tr.id;
}

function competitionDragEnd(event) {
	const tr = findParentRow(event.target);
	tr.classList.remove('dragging');
}

function competitionDragOver(event) {
	const tr = findParentRow(event.target);
	const dragged = document.getElementById(draggedTrId);
	if (tr !== dragged) {
		event.preventDefault();
	}
}

function competitionDragEnter(event) {
	const tr = findParentRow(event.target);
	const dragged = document.getElementById(draggedTrId);
	if (tr !== dragged) {
		tr.classList.add('droptarget');
		event.preventDefault();
	}
}

function competitionDragLeave(event) {
	const tr = findParentRow(event.target);
	tr.classList.remove('droptarget')
}

function competitionDrop(event) {
	const tr = findParentRow(event.target);
	const dragged = document.getElementById(draggedTrId);
	if (dragged) {
		insertCompetitionRowBefore(dragged, tr);
	}
	tr.classList.remove('droptarget');
	event.preventDefault();
}

function draggable(tr) {
	tr.addEventListener('dragstart', competitionDragStart);
	tr.addEventListener('dragenter', competitionDragEnter);
	tr.addEventListener('dragover', competitionDragOver);
	tr.addEventListener('dragleave', competitionDragLeave);
	tr.addEventListener('drop', competitionDrop);
	tr.addEventListener('dragend', competitionDragEnd);
}

function initDragging() {
	document.querySelectorAll('tr[draggable]').forEach(tr => {
		draggable(tr);
		tr.querySelectorAll('td').forEach(td => draggable(td));
	});
}

function deleteCompetitionInternal(row) {
	const table = findParentTable(row);
	row.remove();
	updateCompetitionActionsState(table);
}

function addCompetitionInternal(team) {
	const {template, dateFrom, time, dateTo, group, clazz, kind, remarks, table} = querySelect({
		template: `#team_template_${team}`,
		dateFrom: `#team_${team}_date_from`,
		time: `#team_${team}_time`,
		dateTo: `#team_${team}_date_to`,
		group: `#team_${team}_group`,
		clazz: `#team_${team}_class`,
		kind: `#team_${team}_kind`,
		remarks: `#team_${team}_remarks`,
		table: `#team_${team}_competitions-table`
	});
	const nextIndex = table.querySelectorAll('tbody tr').length;

	const cloned = template.cloneNode(true);
	cloned.id = `added_competition_${addedCompetitionIndex}`;
	addedCompetitionIndex++;
	cloned.innerHTML = cloned.innerHTML.replaceAll('[index]', `[${nextIndex}]`);

	const {newDateFrom, newTime, newDateTo, newGroup, newClass, newKind, newRemarks} = querySelect({
		newDateFrom: '[name="turniere[' + nextIndex + '][date_from]"]',
		newTime: 'input[name="turniere[' + nextIndex + '][time]"]',
		newDateTo: '[name="turniere[' + nextIndex + '][date_to]"]',
		newGroup: 'select[name="turniere[' + nextIndex + '][group]"]',
		newClass: 'select[name="turniere[' + nextIndex + '][class]"]',
		newKind: 'select[name="turniere[' + nextIndex + '][kind]"]',
		newRemarks: 'input[name="turniere[' + nextIndex + '][remarks]"]',
	}, cloned);

	newDateFrom.value = dateFrom.value;
	newTime.value = time.value;
	newDateTo.value = dateTo.value;
	newRemarks.value = remarks.value;
	newGroup.value = group.value;
	newClass.value = clazz.value;
	newKind.value = kind.value;

	time.value = '';
	remarks.value = '';
	time.focus();

	draggable(cloned);

	appendCompetitionRow(cloned, findParentTable(event.target));
}

function getCurrentPageUrl(id) {
	return siteUrl(['zwe', 'veranstaltung', id]);
}

function updateAttachments(id) {
	const currentDocument = document;
	return axios.get(getCurrentPageUrl(id), {responseType: 'document'}).then(
		(response) => {
			const anlagenCurrent = querySelect('#anlagen', currentDocument);
			const anlagenUpdated = querySelect('#anlagen', response.data);
			anlagenCurrent.replaceWith(document.adoptNode(anlagenUpdated));
		}
	)
}

function deleteAssignmentPlanAttachmentInternal(url, eventId) {
	axios.delete(url).then(
		() => Toast.add('success', 'Anlage gelöscht.')
	).catch(
		(error) => {
			console.error('could not delete attachment', {error});
			Toast.add('error', 'Anlage konnte nicht gelöscht werden.')
		}
	).then(
		() => updateAttachments(eventId)
	).catch(
		(error) => {
			console.error('could not update list of attachments', {error});
			Toast.add('error', 'Liste der Anlagen konnte nicht neu geladen werden.')
		}
	)
}

function initDropzone(eventId) {
	if (eventId) {
		new Dropzone('#upload', {
			paramName: 'userfile',
			maxFilesize: 2,
			createImageThumbnails: false,
			dictDefaultMessage: 'Dateien zum Upload auswählen…',
			dictFallbackMessage: 'Ihr Browser wird nicht unterstützt!',
			success: function (file) {
				this.removeFile(file);
				updateAttachments(eventId);
			}
		});
	}
}

function sendRemindersInternal(eventId) {
	const progress = getProgressElement();
	return showProgress(progress).then(
		() => axios.post(siteUrl(['zwe', 'ajax_reminders', eventId]))
	).then(
		(response) => {
			if (response.data.sent > 0) {
				Toast.add('success', `${response.data.sent} Erinnerungen verschickt.`)
			} else {
				Toast.add('warning', 'Keine Erinnerungen verschickt (keine ausstehenden Zusagen).');
			}
		}
	).catch(
		(error) => {
			console.error('could not send reminders', {error});
			Toast.add('error', 'Erinnerungen konnten nicht verschickt werden.');
		}
	).finally(
		() => hideProgress(progress)
	);
}

function cancelEventInternal(eventId) {
	const {cancelRemarks, cancelMode} = querySelect({
		cancelRemarks: '#cancel_remarks',
		cancelMode: 'input[name=cancel_mode]:checked'
	})

	const progress = getProgressElement();
	return showProgress(progress).then(
		() => axios.post(siteUrl(['zwe', 'ajax_cancelevent', eventId]), {
			mode: cancelMode.value,
			remarks: cancelRemarks.value
		})
	).then(
		() => {
			window.location = siteUrl(['zwe', 'veranstaltung', eventId, '#veranstaltung']);
			window.location.reload();
		}
	).finally(
		() => hideProgress(progress)
	);
}

function VeranstaltungsEditor(eventId) {
	Tabs.tab('#veranstaltung').on('activate', () => {
		Chosen.recreate('#veranstaltung');
	});

	initDragging();
	initDropzone(eventId);

	return {
		addWrTeam: function (veranstaltung) {
			const {modalElement, formElement} = querySelect({
				modalElement: '#modalAddWrTeam',
				formElement: '#modalAddWrTeam form',
				progress: '#veranstaltung-progress'
			});
			const form = new FormValidator(formElement, addWrTeamFormValidityChanged.bind(null, modalElement));

			Modal.create('#modalAddWrTeam', {
				onConfirm: function () {
					if (form.validate()) {
						addWrTeam({
							...form.getCurrentFormValue(),
							event: veranstaltung,
						}, getProgressElement());
					}
				}
			});

		},
		deleteWrTeam: function (team) {
			deleteWrTeam(team, getProgressElement())
		},
		moveCompetitionUp: function (evt) {
			evt.preventDefault();
			const row = findParentRow(evt.target);
			const table = findParentTable(row);
			moveCompetition(table, row, true);
		},
		moveCompetitionDown: function (evt) {
			evt.preventDefault();
			const row = findParentRow(evt.target);
			const table = findParentTable(row);
			moveCompetition(table, row, false);
		},
		deleteCompetition: function (evt) {
			evt.preventDefault();
			const row = findParentRow(evt.target)
			const table = findParentTable(row);
			const rowNumber = Array.from(table.querySelectorAll('tbody tr').values()).indexOf(row) + 1;

			const {modalElement, zeileElement} = querySelect({
				modalElement: '#modalDeleteWrTeam',
				zeileElement: '#modalDeleteWrTeam .zeile'
			});
			zeileElement.innerHTML = `${rowNumber}`;

			Modal.create(modalElement, {
				onConfirm: () => {
					deleteCompetitionInternal(findParentRow(evt.target));
				}
			})
		},
		addCompetition: function (event, team) {
			event.preventDefault();
			addCompetitionInternal(team);
		},
		deleteAssignmentPlanAttachment: function (event) {
			event.preventDefault();
			event.target.classList.add('disabled');
			try {
				deleteAssignmentPlanAttachmentInternal(event.target.href, eventId);
			} finally {
				event.target.classList.remove('disabled');
			}
		},
		sendReminders: function (event) {
			event.preventDefault();
			event.target.disabled = true;
			try {
				sendRemindersInternal(eventId);
			} finally {
				event.target.disabled = false;
			}
		},
		toggleCancellation: function (event) {
			const button = querySelect('#cancel_confirm');
			if (event.target.checked) {
				button.disabled = false;
			} else {
				button.disabled = true;
			}
		},

		cancelEvent: function (event) {
			event.preventDefault();
			event.target.disabled = true;
			try {
				cancelEventInternal(eventId);
			} finally {
				event.target.disabled = false;
			}
		}
	}
}

module.exports = VeranstaltungsEditor;
